document.addEventListener("DOMContentLoaded", function() {
    // Currency symbol mapping
    const currencySymbolMapping = {
        GBP: '£',
        USD: '$',
        CAD: '$',
        EUR: '€',
        JPY: '¥',
        AUD: '$'
    };

    // Function to update currency symbols and prices
    function updateCurrencySymbol(currency) {
        console.log("Attempting to update currency symbol for: " + currency); // Log the selected currency
        
        // Select all price elements with the 'money' class
        const priceElements = document.querySelectorAll('.money');
        console.log("Found " + priceElements.length + " price elements."); // Log the number of price elements

        priceElements.forEach(priceElement => {
            // Get the price for the selected currency from the data-attribute
            const price = priceElement.getAttribute(`data-currency-${currency.toLowerCase()}`);
            console.log(`Price for ${currency}: ${price}`); // Log the price for the selected currency
            
            // Get the symbol based on the selected currency
            const symbol = currencySymbolMapping[currency] || '£';  // Default to GBP if not found
            console.log("Currency Symbol: " + symbol); // Log the symbol being applied
            
            // Update the price and currency symbol in the span element
            if (price) {
                // Update the content of the span to show the correct symbol and price
                priceElement.textContent = `${symbol}${parseFloat(price.replace(/[^\d.-]/g, '')).toFixed(2)}`;
            }
        });
    }

    // If Shopify has the currency selector, we can listen to the change event
    const currencySelector = document.querySelector('.currency-picker'); // Update this selector to match your currency dropdown
    console.log("Currency selector found:", currencySelector); // Log whether the currency selector is found

    if (currencySelector) {
        currencySelector.addEventListener('change', function(event) {
            const selectedCurrency = event.target.value;  // Get selected currency code
            console.log("Currency selected: " + selectedCurrency); // Log the selected currency
            updateCurrencySymbol(selectedCurrency);
        });
    }

    // Initialize the page with the current currency in Shopify (use 'GBP' as fallback)
    const currentCurrency = Shopify.currency.active || 'GBP'; // Get current Shopify currency
    console.log("Initial currency: " + currentCurrency); // Log the current currency on page load
    updateCurrencySymbol(currentCurrency);
});
